import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { Row } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { routes } from '~/constants';
import { useLocaleKeys } from '~/i18n';
import IntegrationCard from '../IntegrationCard/IntegrationCard';
import { ViaZapier } from './ViaZapier';
import styles from './ZapierTemplateIntegrationCard.module.scss';
import { getZapierTemplateIntegrationTexts } from './zapierTemplateIntegrationTexts';
export const GetZapierTemplateIntegrationCardTID = (parentTestId)=>getTestIds(parentTestId);
const { ZapierTemplateIntegrationCardTID } = GetZapierTemplateIntegrationCardTID();
export function ZapierTemplateIntegrationCard(param) {
    let { integration } = param;
    const { t: zapierTemplatesTexts } = useLocaleKeys('integrations.availableApps.zapierTemplates');
    const { t: sharedTexts } = useLocaleKeys('integrations.availableApps.shared');
    const texts = getZapierTemplateIntegrationTexts(zapierTemplatesTexts, integration.i18nKey);
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: ZapierTemplateIntegrationCardTID.Card(integration.key),
        icon: /*#__PURE__*/ _jsx(integration.Logo, {
            width: 40,
            height: 40
        }),
        title: texts.title(),
        subTitle: texts.subTitle(),
        mainAction: /*#__PURE__*/ _jsxs(Row, {
            className: styles.mainAction,
            justifyContent: "space-between",
            alignItems: "center",
            children: [
                /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
                    bi: {
                        name: integration.biConnectName
                    },
                    as: Link,
                    to: routes.zapierTemplatesIntegration(integration.key),
                    testId: ZapierTemplateIntegrationCardTID.Connect(integration.key),
                    children: sharedTexts.connectButton()
                }),
                /*#__PURE__*/ _jsx(ViaZapier, {})
            ]
        })
    });
}
